import { NgModule } from '@angular/core';

import { InfiniteScroll } from './infinite-scroll';
import { AxisResolverFactory } from './axis-resolver';
import { PositionResolverFactory } from './position-resolver';
import { ScrollRegister } from './scroll-register';
import { ScrollResolver } from './scroll-resolver';


export class InfiniteScrollModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [],
  declarations: [InfiniteScroll],
  exports: [InfiniteScroll],
  providers: [
    AxisResolverFactory,
    PositionResolverFactory,
    ScrollRegister,
    ScrollResolver
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// index.ts